
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { resetPassword, ResetPasswordRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useResetPassword = () => {
  const { replace } = useRouter();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: ResetPasswordRequest) => {
      return resetPassword(body);
    },
    onSuccess: () => {
      openToast({ variant: "success", message: "Your password has been updated!" });

      setTimeout(() => replace("/auth/login"), 1500);
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useResetPassword };
